import React from 'react';

import { Close } from '@lyearn/icons';
import { LinkButton } from '@lyearn/ui';

import useSearchState from '../Search/hooks/useSearchState';
import SearchInput from './SearchInput';
import type { SearchBarProps } from './types';

function SearchBarWithEmptyStateAdornment(props: SearchBarProps) {
  const { value, startAdornment, endAdornment, onChange, appearance } = props;
  const { searchText, setSearchText, debounceOnChange } = useSearchState({ value, onChange });
  const _onChange = React.useCallback(
    (searchValue: string) => {
      setSearchText(searchValue);
      debounceOnChange(searchValue);
    },
    [debounceOnChange, setSearchText],
  );

  const resolvedEndAdornment = value.length ? (
    <LinkButton color={'internal'} onClick={() => _onChange('')}>
      <Close className="icon-close fill-current text-icon-placeholder hover:text-icon-active" />
    </LinkButton>
  ) : (
    endAdornment || null
  );

  return (
    <SearchInput
      {...props}
      appearance={appearance}
      endAdornment={resolvedEndAdornment}
      startAdornment={startAdornment}
      value={searchText}
      onChange={_onChange}
    />
  );
}

export default React.memo(SearchBarWithEmptyStateAdornment);
